module.exports = __webpack_public_path__ + "media/images/svg/real_estate_agent-af9bbce0941f654bafc5f5415b5d2158.svg";